import { mergeStyleSets } from '@uifabric/merge-styles';
import { layout } from '../../theme.style';

export default mergeStyleSets({
  root: {
    padding: '0 1rem',
    selectors: {
      [layout.breakpoints.min.md]: {
        padding: '0 1.5rem',
      },
    },
  },
});
